module.exports = __webpack_public_path__ + "static/media/decimal-point-default-value-1.841e0a49.png";